const REPORT_PLAN_SLOTS = ['planA', 'planB', 'planC', 'planD']

// Normalize both current multi-plan report payloads and older single-plan
// payloads into an explicit store seed. Empty slots are always cleared so a
// report opened beside the app cannot inherit one of the app's compared plans.
export function buildReportStoreSeed(state = {}) {
  const payloadPlans = state.plans || {}
  const plans = Object.fromEntries(REPORT_PLAN_SLOTS.map((key) => [
    key,
    payloadPlans[key] || (key === 'planA' ? state.plan : null) || null,
  ]))
  return {
    ...plans,
    activePlanKey: 'planA',
    // Hidden app plans are removed from the payload before this point. Clear
    // any persisted UI visibility state when the standalone viewer hydrates.
    hiddenPlanKeys: [],
    customCharts: state.customCharts || [],
    reportConfig: state.reportConfig || {},
    workspaceMode: state.workspaceMode || 'actual',
    ...(state.censusLocal ? { censusLocal: state.censusLocal } : {}),
  }
}

export { REPORT_PLAN_SLOTS }
